module.exports = __webpack_public_path__ + "static/media/homepage_banner.7db2c958.png";